module.exports = __webpack_public_path__ + "img/community.73362bf6.svg";